export default __webpack_public_path__ + "static/media/corner_view.d12872fc.png";